import { type ErrorComponentProps, type NotFoundRouteProps, Outlet } from '@tanstack/react-router';
import { Dashboard } from '@/components/Dashboard/Dashboard';
import { DefaultErrorFallback, DefaultNotFoundFallback } from '@/components/Error';

export const DashboardComponent = () => (
  <Dashboard>
    <Outlet />
  </Dashboard>
);

export function DashboardErrorFallback(props: ErrorComponentProps) {
  return (
    <Dashboard>
      <DefaultErrorFallback {...props} />
    </Dashboard>
  );
}

export function DashboardNotFoundFallback(props: NotFoundRouteProps) {
  return (
    <Dashboard>
      <DefaultNotFoundFallback {...props} />
    </Dashboard>
  );
}
